// Medical records with attached files (v1, owner-scoped).
import api, {withIdempotencyKey} from './client';

const toRecord = (r) => ({...r});

export const getAllMedicalRecord = (sequence, dateRange) => {
  const q = new URLSearchParams({order: sequence === 'ascending' ? 'asc' : 'desc'});
  if (dateRange && dateRange[0]) q.set('start_date', dateRange[0]);
  if (dateRange && dateRange[1]) q.set('end_date', dateRange[1]);
  return api.get(`/me/medical-records?${q}`).then((r) => r.data.map(toRecord));
};

export const getMedicalRecordById = (id) =>
  api.get(`/me/medical-records/${id}`).then((r) => toRecord(r.data));

export const createMedicalRecord = (d, opts = {}) =>
  api
    .post(
      '/me/medical-records',
      {
        title: d.title,
        record_date: d.record_date,
        note: d.note || '',
        medical_files: (d.medical_files || []).map((f) => ({
          file_name: f.file_name,
          file: f.file_link || f.file,
        })),
      },
      withIdempotencyKey(opts.idempotencyKey),
    )
    .then((r) => toRecord(r.data));

export const updateMedicalRecord = (id, d) =>
  api.patch(`/me/medical-records/${id}`, {
    ...(d.title !== undefined && {title: d.title}),
    ...(d.record_date !== undefined && {record_date: d.record_date}),
    ...(d.note !== undefined && {note: d.note}),
  });

export const deleteMedicalRecord = (id) => api.delete(`/me/medical-records/${id}`);

export const createMedicalFile = (recordId, f, opts = {}) =>
  api
    .post(
      `/me/medical-records/${recordId}/files`,
      {file_name: f.file_name, file: f.file_link || f.file},
      withIdempotencyKey(opts.idempotencyKey),
    )
    .then((r) => r.data);

export const deleteMedicalFile = (recordId, fileId) =>
  api.delete(`/me/medical-records/${recordId}/files/${fileId}`);
